import vueI18n from 'vue-i18n'
import Vue from 'vue'
import langEn from './en.json'
import langZh from './zh.json'
import langJap from './jap.json'
import cookies from '@/libs/utils/cookie.js'
let locale = cookies.getCookie('lang')
if(!locale){
  locale='zh'
}
Vue.use(vueI18n)
const i18n = new vueI18n({
  locale:locale,
  messages:{
    en: langEn,
    zh: langZh,
    jap: langJap
  }
})
export default i18n


// WEBPACK FOOTER //
// ./src/lang/index.js